import React from "react";
import { Modal, Form } from "react-bootstrap";

interface DeleteWorkflowRunModalProps {
  show: boolean;
  handleClose: () => void;
  message: string;
  method: () => void;
}
const DeleteWorkflowRunModal = ({
  show,
  handleClose,
  message,
  method,
}: DeleteWorkflowRunModalProps) => {
  return (
    <Modal className="DeleteModal" show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="clearConPopupHeader border-0">
        <Modal.Title>Workflow history</Modal.Title>
      </Modal.Header>
      <Modal.Body className={`DeleteModalBody border-0 rounded-bottom-4 px-0`}>
        <div className="deleteRequirements d-flex flex-column align-items-center justify-content-center">
          <div className="mb-1 w-100 d-flex flex-column px-4">
            <p className="warningDeleteText text-start">{message}</p>
          </div>
          <div className="line popup"></div>
          <div className="d-flex pb-2 pe-3 buttons w-100 justify-content-end">
            <button className="cancelDeleteBtn mx-2" onClick={handleClose}>
              Cancel
            </button>
            <button className="confirmDeleteBtn mx-2 py-3" onClick={method}>
              Confirm
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteWorkflowRunModal;
